"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateDriverWork = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const L = require("leaflet");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/driver/classes/models");
const gs_1 = require("@ivanlog/gs");
const OrderStateEnum_1 = require("../../enums/OrderStateEnum");
class StateDriverWork extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageDriverWork, "Work", true);
        const c = this.page.ctrls;
        c.btnStart.onclick = () => this._tryStart();
        c.btnStop.onclick = () => this._tryStop();
        c.btnUpdate.onclick = () => this._tryUpdateLocation();
        c.btnPause.onclick = () => this._tryPause();
        c.btnStopPause.onclick = () => this._tryStopPause();
        this._hideAllBlocks();
        this._hideAllContolBtns();
        c.btnOrderUntake.onclick = () => this._tryUntakeOrder();
        c.btnOrderDriveBy.onclick = () => this._tryChangeOrderStatus(OrderStateEnum_1.OrderStateEnum.MoveByOrder);
        c.btnOrderWaitForCustomer.onclick = () => this._tryChangeOrderStatus(OrderStateEnum_1.OrderStateEnum.WaitForCustomer);
        c.btnOrderWaitLoading.onclick = () => this._tryChangeOrderStatus(OrderStateEnum_1.OrderStateEnum.WaitLoading);
        c.btnOrderWaitUnloading.onclick = () => this._tryChangeOrderStatus(OrderStateEnum_1.OrderStateEnum.WaitUnloading);
        c.btnOrdeWaitPay.onclick = () => this._tryChangeOrderStatus(OrderStateEnum_1.OrderStateEnum.WaitPay);
        c.btnOrderDriveTo.onclick = () => this._tryChangeOrderStatus(OrderStateEnum_1.OrderStateEnum.MoveToOrder);
        c.btnOrderExecute.onclick = () => this._tryChangeOrderStatus(OrderStateEnum_1.OrderStateEnum.Executed);
        // c.btnOrderWait.onclick = ()=>this._tryChangeOrderStatus(OrderStateEnum.Wait);
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this._refresh();
            return _super.start.call(this);
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            this._initMap();
        });
    }
    _refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.rbVehicles.html = '';
            this.page.ctrls.rbTakedOrders.html = '';
            this._activeVehicle = yield this.lockgui(this.app.api.driver.work.status());
            if (!this._activeVehicle)
                return;
            if (this._activeVehicle.vehicleId == 0) {
                var vehicles = yield this.lockgui(this.app.api.driver.work.vehicles());
                for (const v of vehicles) {
                    const btn = gs.w(gs.html.tag('button', { class: `${gs_1.ItemButton.TagClassName}` }, v.govNumber));
                    btn.setData(gs_1.ItemButton.TagDataValue, v.id.toString());
                    this.page.ctrls.rbVehicles.append(btn);
                }
                this._hideAllBlocks();
                this.page.ctrls.blockStartWork.show();
            }
            else {
                this._hideAllBlocks();
                this.page.ctrls.blockWork.show();
                const activeOrders = yield this.lockgui(this.app.api.driver.orders.myActive());
                if (activeOrders) {
                    if (activeOrders.length > 0) {
                        this.page.ctrls.blockOrder.show();
                    }
                    let orderSelected = false;
                    for (const ao of activeOrders) {
                        const btn = gs.w(gs.html.tag('button', { class: `${gs_1.ItemButton.TagClassName}` }, gs.date.getShortTime(ao.route.departureTime)));
                        btn.setData(gs_1.ItemButton.TagDataValue, ao.id.toString());
                        this.page.ctrls.rbTakedOrders.append(btn);
                        if (!orderSelected) {
                            btn.addClass('selected');
                            this._selectOrder(ao);
                            orderSelected = true;
                        }
                        btn.onclick = () => this._selectOrder(ao);
                    }
                }
            }
        });
    }
    _initMap() {
        let coordinates = new models_1.Coordinates({ lat: 48.142723, lng: 11.576843 });
        if (this._activeVehicle.vehicleId != 0)
            coordinates = this._activeVehicle.coordinates;
        this._map = L.map('map').setView(coordinates, 10);
        let icon = L.icon({
            iconUrl: 'images/icons/map-pin_driver.svg',
            iconSize: [30, 60],
            iconAnchor: [15, 45]
        });
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(this._map);
        this._mapMarker = L.marker(this._map.getCenter(), { icon: icon }).addTo(this._map);
        this._map.on("click", (ev) => {
            this._mapMarker.setLatLng(ev.latlng);
        });
    }
    _tryStart() {
        return __awaiter(this, void 0, void 0, function* () {
            var item = this.page.ctrls.rbVehicles.getSelectedItem();
            if (!item)
                return;
            var vehicleId = item.value;
            var req = new models_1.ActiveVehicleRequest();
            req.vehicleId = parseInt(vehicleId);
            req.coodinates = new models_1.Coordinates(this._mapMarker.getLatLng());
            let av = yield this.lockgui(this.app.api.driver.work.start(req));
            if (!av)
                return;
            this._activeVehicle = av;
            this._hideAllBlocks();
            this.page.ctrls.blockWork.show();
            yield this._refresh();
        });
    }
    _tryStop() {
        return __awaiter(this, void 0, void 0, function* () {
            let av = yield this.lockgui(this.app.api.driver.work.stop());
            if (!av)
                return;
            yield gs_1.StateGS.RunInstance(new StateDriverWork());
        });
    }
    _tryUpdateLocation() {
        return __awaiter(this, void 0, void 0, function* () {
            var coordinates = new models_1.Coordinates(this._mapMarker.getLatLng());
            let av = yield this.lockgui(this.app.api.driver.work.updatePosition(coordinates));
            if (!av)
                return;
            this._activeVehicle = av;
            new modalCom.DialogOk("Position updated");
        });
    }
    _tryPause() {
        return __awaiter(this, void 0, void 0, function* () {
            let av = yield this.lockgui(this.app.api.driver.work.updateStatus(false));
            if (!av)
                return;
            this.page.ctrls.btnPause.hide();
            this.page.ctrls.btnStopPause.show();
        });
    }
    _tryStopPause() {
        return __awaiter(this, void 0, void 0, function* () {
            let av = yield this.lockgui(this.app.api.driver.work.updateStatus(true));
            if (!av)
                return;
            this.page.ctrls.btnPause.show();
            this.page.ctrls.btnStopPause.hide();
        });
    }
    _hideAllBlocks() {
        this.page.ctrls.blockStartWork.hide();
        this.page.ctrls.blockWork.hide();
        this.page.ctrls.blockOrder.hide();
    }
    _hideAllContolBtns() {
        const c = this.page.ctrls;
        c.btnOrderDriveTo.hide();
        c.btnOrderWaitForCustomer.hide();
        c.btnOrderWaitLoading.hide();
        c.btnOrderWaitUnloading.hide();
        c.btnOrdeWaitPay.hide();
        c.btnOrderDriveBy.hide();
        c.btnOrderExecute.hide();
        c.btnOrderUntake.hide();
    }
    _selectOrder(order) {
        const fromLocation = order.route.locations[0];
        const toLocation = order.route.locations[order.route.locations.length - 1];
        let info = `<b>Order info</b><br>` +
            `State: ${order.state}<br>` +
            `From: ${fromLocation.addressFull}<br>` +
            `To: ${toLocation.addressFull}<br>` +
            `Start time: ${gs.date.getShortTime(order.route.departureTime)}<br>`;
        `State: ${order.state}<br>`;
        if (!order.finalPrice)
            info += `Est.price: ${order.estimatedPrice}<br>`;
        else
            info += `Final price: ${order.finalPrice}<br>`;
        if (order.finalPrice)
            info += `<br><b>Check</b>: <br>${gs.text.replaceAll(order.finalCheck, '\r\n', "<br>")}<br><br>`;
        this.page.ctrls.lOffer.html = info;
        this._selectedOrder = order;
        this._hideAllContolBtns();
        const c = this.page.ctrls;
        switch (OrderStateEnum_1.OrderStateEnum[order.state]) {
            case OrderStateEnum_1.OrderStateEnum.Taked:
                c.btnOrderUntake.show();
                c.btnOrderDriveTo.show();
                break;
            case OrderStateEnum_1.OrderStateEnum.MoveToOrder:
                c.btnOrderWaitForCustomer.show();
                break;
            case OrderStateEnum_1.OrderStateEnum.WaitForCustomer:
                c.btnOrderWaitLoading.show();
                c.btnOrderWaitForCustomer.hide();
                break;
            case OrderStateEnum_1.OrderStateEnum.WaitLoading:
                c.btnOrderDriveBy.show();
                c.btnOrderWaitLoading.hide();
                break;
            case OrderStateEnum_1.OrderStateEnum.MoveByOrder:
                c.btnOrderWaitUnloading.show();
                c.btnOrderWaitLoading.hide();
                break;
            case OrderStateEnum_1.OrderStateEnum.WaitUnloading:
                c.btnOrdeWaitPay.show();
                c.btnOrderWaitUnloading.hide();
                break;
            case OrderStateEnum_1.OrderStateEnum.WaitPay:
                c.btnOrderExecute.show();
                break;
        }
    }
    _tryUntakeOrder() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._selectedOrder)
                return;
            const req = new models_1.OrderRequest();
            req.orderId = this._selectedOrder.id;
            const responce = yield this.lockgui(this.app.api.driver.orders.untakeActive(req));
            if (!responce)
                return;
            yield this._refresh();
        });
    }
    _tryChangeOrderStatus(newState) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._selectedOrder)
                return;
            const req = new models_1.OrderStateChangeRequest();
            req.orderId = this._selectedOrder.id;
            req.newState = newState.toString();
            const responce = yield this.lockgui(this.app.api.driver.orders.changeActiveState(req));
            if (!responce)
                return;
            yield this._refresh();
        });
    }
}
exports.StateDriverWork = StateDriverWork;
StateDriverWork.StateName = "driverWork";
//# sourceMappingURL=StateDriverWork.js.map